import { render, staticRenderFns } from "./effect-table.vue?vue&type=template&id=29d36509&scoped=true"
import script from "./effect-table.vue?vue&type=script&lang=js"
export * from "./effect-table.vue?vue&type=script&lang=js"
import style0 from "./effect-table.vue?vue&type=style&index=0&id=29d36509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d36509",
  null
  
)

export default component.exports